/** Ошибка для показа в интерфейсе пользователя. */
export class AppError extends Error { }
